import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";
import { testimonialSchema } from "./schema";
import { fetchTestimonialData } from "./read";
import { useUpdateTestimonial } from "../update/mutation";
import { useCreateTestimonial } from "../create/mutation";

export const useTestimonialForm = ({ clientId }) => {
  const form = useForm({
    resolver: zodResolver(testimonialSchema),
    defaultValues: {
      feedback: "",
      video: null,
      review_url: "",
    },
  });

  const requiredFields = useMemo(() => getRequiredFields(testimonialSchema), []);

  const updateTestimonial = useUpdateTestimonial();
  const createTestimonial = useCreateTestimonial();

  const handleCreate = async (context) => {
    const item = { ...context.values, client: clientId };
    await createTestimonial.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    await updateTestimonial.mutateAsync({
      testimonialId: id,
      item: context.dirtyValues,
    });
  };

  const handleRead = async (id) => {
    return fetchTestimonialData({ testimonialId: id });
  };

  return { form, requiredFields, handleCreate, handleUpdate, handleRead };
};
